// extracted by mini-css-extract-plugin
module.exports = {"on":"toggle-module--on--17o6r","off":"toggle-module--off--U6tpJ"};